import FooterButtons from 'components/inputs/Material/FooterButtons/index'
import Info from 'components/inputs/Material/Info/index'
import OptionsBlockContent from 'components/inputs/Material/OptionsBlockContent'
import { FormFieldsContainer } from '../Shared/styles'

export default function AI123() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
        <OptionsBlockContent isFalaGPT />
      </FormFieldsContainer>
      <FooterButtons showLogicButton={false} />
    </>
  )
}
